// Handles ambassador shared URL. This is for users who have received a shared URL from the VIP/G5G5 program.
// Keywords for search: ambassador, shared URL, VIP bracelet program, G5G5
// Any type of purchase made with the shared URL will be tracked and the user will see their VIP count increase.

function BrandAmbassador() {
  function getCart() {
    return fetch(`${window.Shopify.routes.root}cart.js`)
      .then((response) => response.json())
      .then((data) => {
        return data;
      });
  }

  function updateCartAttributes(payload) {
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        return data;
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  // if ambassador shared url
  const urlParams = new URLSearchParams(window.location.search);
  // get ambassador param and app user id from url
  const isAmbassadorSharedURL = urlParams.get('is_ambassador_url');
  const appUserId = urlParams.get('app_user_id');
  // set storage session for ambassador and app user id incase user navigates away from page
  if (isAmbassadorSharedURL && appUserId) {
    sessionStorage.setItem('fahlo_is_ambassador_url', isAmbassadorSharedURL);
    sessionStorage.setItem('fahlo_app_user_id', appUserId);
  }

  // get ambassador and app user id from session storage
  const sessionAmbassadorURL = sessionStorage.getItem('fahlo_is_ambassador_url');
  const sessionAppUserId = sessionStorage.getItem('fahlo_app_user_id');
  if (sessionAmbassadorURL && sessionAppUserId) {
    // set value for hidden fields for product pages
    const ambassadorAttributeFields = document.querySelectorAll('input[name="attributes[is_ambassador_url]"]');
    const appUserIdAttributeFields = document.querySelectorAll('input[name="attributes[app_user_id]"]');
    if (ambassadorAttributeFields.length > 0) {
      ambassadorAttributeFields.forEach((field) => {
        field.value = sessionAmbassadorURL;
      });
    }
    if (appUserIdAttributeFields.length > 0) {
      appUserIdAttributeFields.forEach((field) => {
        field.value = sessionAppUserId;
      });
    }
  } else {
    // update cart if a new session and no ambassador url
    const cart = getCart((cartInside) => {
      return cartInside;
    });
    cart
      .then((cartInside) => {
        const { attributes } = cartInside;
        const isAmbassadorURL = attributes.is_ambassador_url;
        const applicationUserId = attributes.app_user_id;
        if (cart && isAmbassadorURL && applicationUserId) {
          // update cart attributes
          const newCart = {
            ...cart,
            attributes: {
              is_ambassador_url: null,
              app_user_id: null,
            },
          };
          updateCartAttributes(newCart);
        }
      })
      .catch((error) => console.error(error));
  }
}

if (
  document.body.classList.contains('page-type-index') ||
  document.body.classList.contains('page-type-product') ||
  document.body.classList.contains('bracelets-overview') ||
  document.body.classList.contains('plushes-overview')
) {
  BrandAmbassador();
}
